export function getFamilyTreeClanModalReviewedIdentifier(familyTreeId, surname) {
  return `family-tree-${familyTreeId}-surname-${surname}`;
}
export function getFamilyTreeClanModalReviewedIdentifierRegex() {
  return `family-tree-.*-surname-(.*)`;
}
